import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { TypeKeys } from "./TypeKeys";

export class PositionCorrectItem extends AbstractRectangleItem {
  constructor() {
    super(TypeKeys.PositionCorrectItem);
    this.isPositionFixed = true;
  }
 
  protected createCloneInstance(): PositionCorrectItem {
    return new PositionCorrectItem();
  }
}
